import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7b33839a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "onedesk-component-container" };
import { ref, watch } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InventoryWebsitesTable',
    props: {
        tableData: { default: () => [] },
        columnsDefinition: { default: () => [] },
        hasPagination: { type: Boolean, default: false },
        headerClass: { default: "" },
        groupedValue: { default: "brand" },
        onRowClick: { type: Function, default: () => true },
        pageIndex: { default: 1 },
        pageSize: { default: 10 },
        totalRecords: { default: 0 }
    },
    emits: ["page-change"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const onPageChange = (event) => {
            if (datatable.value != null && datatable.value != undefined && event.page != currentPage.value) {
                datatable.value.getElementsByClassName("p-datatable-wrapper")[0].scrollTop = 0;
                currentPage.value = event.page;
                emit('page-change', Number(event.page));
            }
        };
        const rowClick = (event) => {
            props.onRowClick(event.data);
        };
        const datatable = ref();
        const currentPage = ref(0);
        const firstRecordIndex = ref(0);
        const loading = ref(false);
        watch(() => props.groupedValue, () => {
            loading.value = true;
            setTimeout(() => (loading.value = false), 1);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    ref_key: "datatable",
                    ref: datatable,
                    class: "inventory-sub-table-container"
                }, [
                    _createVNode(_unref(DataTable), {
                        value: _ctx.tableData,
                        paginator: _ctx.hasPagination,
                        class: "inventory-sub-table",
                        "responsive-layout": "scroll",
                        page: firstRecordIndex.value,
                        "row-class": () => 'one-desk-table-row',
                        "data-key": _ctx.groupedValue,
                        onRowClick: rowClick,
                        rows: _ctx.pageSize,
                        lazy: "",
                        totalRecords: _ctx.totalRecords,
                        first: (_ctx.pageIndex - 1) * _ctx.pageSize,
                        "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                        onPage: onPageChange,
                        currentPageReportTemplate: "{first} to {last} of {totalRecords}"
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsDefinition, (item) => {
                                return (_openBlock(), _createBlock(_unref(Column), {
                                    key: item.field,
                                    field: item.field,
                                    header: item.header,
                                    sortable: item.sortable,
                                    style: _normalizeStyle(item.field != 'siteName' ? { width: '200px' } : ''),
                                    "header-class": 'inventory-sub-table-header ' + _ctx.headerClass
                                }, _createSlots({ _: 2 }, [
                                    (item.hasSlot)
                                        ? {
                                            name: "body",
                                            fn: _withCtx((slotProps) => [
                                                _renderSlot(_ctx.$slots, item.field, {
                                                    item: slotProps.data
                                                })
                                            ]),
                                            key: "0"
                                        }
                                        : undefined
                                ]), 1032, ["field", "header", "sortable", "style", "header-class"]));
                            }), 128))
                        ]),
                        _: 3
                    }, 8, ["value", "paginator", "page", "data-key", "rows", "totalRecords", "first"])
                ], 512)
            ]));
        };
    }
});
